import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class SubpropertyPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.subpropertyRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.subpropertyImport,
    );
    this.subpropertyAutocomplete = permissionChecker.match(
      Permissions.values.subpropertyAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.subpropertyCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.subpropertyEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.subpropertyDestroy,
    );
  }
}
